import React from 'react';
import styled from 'styled-components/macro';

import { classes, palette, breakPoint, size, zIndex, BackButton, CloseButton } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import SignupBackground from '@mirinae/explorer/components/userauth/SignupBackground';

export const LogoHolder = styled.div`
    text-align: center;
    svg {
        vertical-align: middle;
    }
`;

export const Title = styled.div`
    color: ${palette.green.middle};
    font-size: 20px;
    font-weight: 800;

    .${classes.desktop} & {
        margin-bottom: 10px;
    }
    .${classes.mobile} & {
        width: 100%;
    }
    span {
        color: ${palette.point.black};
        font-size: 13px;
        font-weight: 700;
    }
`;

export const TitleWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 10px;

    ${Title} {
        margin-bottom: 0;
    }
`;
export const TitleButtonWrapper = styled.div`
    margin-bottom: 20px;
    text-align: center;
`;
export const Step = styled.div`
    align-self: flex-end;
    margin-bottom: 2px;
    margin-left: 10px;
    color: ${palette.point.black};
    font-size: 13px;
    font-weight: 500;

    span {
        color: ${palette.green.middle};
    }
`;
export const FailMessage = styled.div`
    width: 100%;
    margin-right: 10px;
    color: ${palette.point.orange};
    font-size: 12px;
    line-height: 21px;
    ${props => props.type === 'layer' && ('text-align: right;')}
`;
export const FormSubmit = styled.div`
    display: flex;
    justify-content: ${props => (props.theme === 'login' ? 'space-between' : 'flex-end')};

    ${props => ({ ...props.style })}
    .${classes.mobile} & {
        width: 100%;
    }
`;
export const FormWrapMobile = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
`;
export const FormTable = styled.div`
    width: 100%;
    .${classes.desktop} & {
        padding-top: 10px;
    }
`;
export const FormRow = styled.div`
    display: flex;
    justify-content: space-between;

    .${classes.mobile} & {
        @media only screen and (orientation: portrait) {
            flex-wrap: wrap;
        }
    }
`;
export const FormCell = styled.div`
    .${classes.desktop} & {
        width: 220px;
        margin-bottom: 20px;
        // height: 63px;
        @media only screen and (max-width: ${breakPoint.sm}) {
            width: 210px;
        }
    }
    .${classes.mobile} & {
        width: 100%;
        margin-top: 20px;

        @media only screen and (orientation: landscape) {
            max-width: 220px;
            margin-right: 10px;
            & + ${FormSubmit} {
                margin-top: 42px;
            }
        }
    }
    & + ${FormSubmit} {
        margin-top: 22px;
    }
`;
export const FormSpan = styled.div`
    margin-top: 20px;
    a {
        color: ${palette.green.middle};
        &:hover {
            text-decoration: underline;
        }
    }
    div:last-child {
        padding-left: 20px;
    }
`;
export const SNSButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .${classes.mobile} & {
        padding-top: 20px;
    }
`;
export const FormText = styled.div`
    margin-bottom: 20px;
    padding-top: 10px;
    color: ${palette.point.black};
    font-size: 20px;
    font-weight: 800;
    cursor: pointer;
`;
export const FormLink = styled.div`
    color: ${palette.point.gray};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    .${classes.mobile} & {
        margin-top: 15px;
    }
    &:hover {
        text-decoration: underline;
    }
`;
export const LoginFunc = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 10px;

    .${classes.mobile} & {
        width: 100%;
    }

    a {
        font-size: 10px;
        font-weight: 700;
        color: ${palette.green.middle};
        &:hover {
            text-decoration: underline;
        }
    }
`;

const SignUpWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 103px);

    .${classes.mobile}#withdraw-page &,
    .${classes.mobile}#reset-page & {
        padding: ${size.header} 20px 0;
        min-height: calc(100vh - ${size.header});
    }
`;
const FlexBox = styled.div`
    .${classes.desktop} & {
        display: flex;
        justify-content: center;
        align-items: center;

        @media only screen and (max-width: ${breakPoint.sm}) {
            padding: 0 20px;
        }
        &.large {
            width: 530px;
            flex-direction: column;
        }
        [lang=es] & {
            width: 530px;
        }
    }

    .${classes.mobile} & {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 475px;
    }
`;
const BackButtonWrapper = styled.div`
    position: absolute;
    left: ${os.isOthers ? '30px' : '20px'};
    top: ${os.isOthers ? '30px' : '20px'};

    button {
        color: ${palette.gray[1]};
    }
`;

const UserAuthComponent = props => {

    return (
        <>
            <SignUpWrapper>
                <FlexBox className={props.className}>
                    {props.children}
                </FlexBox>
                {props.onClick && (
                    <BackButtonWrapper>
                        {os.isOthers ? <BackButton onClick={props.onClick}>Back</BackButton> :  <CloseButton onClick={props.onClick} />}
                    </BackButtonWrapper>
                )}
            </SignUpWrapper>
            {(props.theme !== 'reset' && props.theme !== 'withdraw') && <SignupBackground theme={props.theme} />}
        </>
    );
};

export default UserAuthComponent;

// delete member
export const WithdrawMessage = styled.div`
    width: 100%;
    padding-top: 10px;
    color: ${palette.point.gray};
    font-size: 13px;
`;

export const WithdrawButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 20px;

    button {
        min-width: 83px;
    }
`;

// withdrawal survey
export const WithdrawSurvey = styled.div`
    width: 100%;
    padding: 20px 0 0;
`;
export const WithdrawSurveyItem = styled.div`
    height: 15px;
    margin-bottom: 10px;
    line-height: 15px;
    font-size: 11px;
`;
export const WithdrawSurveyInput = styled.div`
    padding-left: 20px;
    input {
        width: 100%;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #c4c4c4;
        font-size: 11px;
        text-indent: 5px;
        color: ${palette.gray.dark};
        &:disabled {
            opacity: .7;
        }
    }
`;

export const SignupWrapper = styled.div`
    margin: 0 auto ${size.header};

    .${classes.desktop} & {

    }
    .${classes.mobile} & {
        max-width: 330px;
        width: 100%;
    }
`;
export const LoginWrapper = styled.div`
    width: 320px;
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 4px 2px 16px rgba(159, 188, 186, 0.3);
    ${props => (props.theme === 'popup' ? `
        & > button {
            position: absolute;
            right: 15px;
            top: 15px;
        }
    ` : `
        margin: 0 auto ${size.header};
    `)}
`;

export const LoginPopupLayout = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${zIndex.feedbackPopup};
    background-color: rgba(0, 0, 0, .4);
    & > div {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;